import { attendanceRoutes } from './modules/attendance';
import {
  employeeRoutes,
  employeeSettingRoutes,
  legacyEmployeeRoutes,
} from './modules/employee';
import { payrollRoutes } from './modules/payroll';
import { performanceRoutes } from './modules/performance';
import { socialInsuranceRoutes } from './modules/socialInsurance';

export type AppRoute = {
  path: string;
  key?: string;
  name?: string;
  icon?: string;
  component?: string;
  redirect?: string;
  layout?: false;
  hideInMenu?: boolean;
  access?: string;
  permissionResourceCode?: string;
  parentKeys?: string[];
  wrappers?: string[];
  routes?: AppRoute[];
};

const routes: AppRoute[] = [
  { path: '/callback', layout: false, component: './callback' },
  {
    path: '/user',
    layout: false,
    routes: [
      { name: 'login', path: '/user/login', component: './user/login' },
      { path: '/user/access-denied', component: './user/access-denied' },
    ],
  },
  {
    path: '/candidate-onboarding/:token',
    layout: false,
    component: '@/modules/zy-hr/pages/CandidateOnboardingPage',
  },
  {
    path: '/profile-completion',
    layout: false,
    component: '@/modules/zy-hr/pages/ProfileCompletionPage',
  },
  ...employeeRoutes,
  ...attendanceRoutes,
  ...payrollRoutes,
  ...socialInsuranceRoutes,
  ...performanceRoutes,
  {
    path: '/settings',
    name: '设置',
    icon: 'setting',
    routes: [
      {
        path: '/settings',
        hideInMenu: true,
        component: './Platform/OverviewRedirect',
      },
      {
        path: '/settings/permissions',
        name: '权限管理',
        icon: 'safetyCertificate',
        access: 'permission',
        component: './Permissions',
      },
      {
        path: '/settings/model-settings',
        name: '模型设置',
        icon: 'robot',
        access: 'modelSettings',
        component: './ModelSettings',
      },
      ...employeeSettingRoutes,
    ],
  },
  ...legacyEmployeeRoutes,
  ...['/', '/home'].map((path) => ({
    path,
    hideInMenu: true,
    component: './Platform/OverviewRedirect',
  })),
  { path: '*', layout: false, component: './404' },
];
export default routes;
